module.exports = __webpack_public_path__ + "static/media/Icons_Public_Document_Centre_Policies.6470964b.png";